const formFieldsStyle = {
    field: {

    },
}

export default formFieldsStyle;